import React, { useEffect } from "react";
import ScrollTriggerSimple from "../helpers/scrollTriggerSimple";

function Design() {
  const buttonclassName =
    "xs:block xs:m-auto lg:mt-16 lg:ml-0 lg:display-inline content-center text-xs  bg-transparent hover:bg-[#EDB6A2] text-[#EDB6A2] sm:text-[16px] sm:leading-[25px] xl:text-[20px] xl:leading-[30px] font-gothMed hover:text-white py-3 px-8 border border-[#707070] hover:border-transparent rounded";

  const { ref: designCopy1 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  const { ref: designImage1 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  // const { ref: designImage2 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  const { ref: designCopy2 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  const { ref: designImage3 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  const { ref: designImage4 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  const { ref: designCopy3 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  // const { ref: designImage5 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  const { ref: designCopy4 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  const { ref: designImage6 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  const { ref: designCta } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");

  useEffect(() => {});

  return (
    <>
      <section className="overflow-hidden">
        <article className="xs:py-20 xs:px-10 lg:px-36 sm:py-36 md:py-36 lg:py-30 bg-[#141833] flex">
          <p ref={designCopy1} className="content-center xs:text-xl sm:text-3xl md:text-3xl text-[#EDB6A2] md:w-[700px] lg:text-3xl lg:!leading-[2.8rem] lg:w-[900px] xl:text-3xl xl:!leading-[2.8rem] xl:w-[825px] sm:px-4 xl:px-12 font-ppNeue">
            Chaldean Prime interiors are bespoke, our homes possess their own charms, intricacies, character and attractions, yet share our trademark astonishing attention to detail.
          </p>
        </article>
        <article className="text-right bg-[#141833]">
          <img ref={designImage1} className="inline-block" alt="" src="../images/design1.jpg"></img>
        </article>
        <article className="text-center bg-[#141833]">
          <video className="inline-block xs:w-full lg:w-3/6 xs:pt-20 sm:pt-36" src="../video/Chaldan_video.mp4" width="800" height="400" autoplay="true" />
        </article>
        <article className="xs:py-20 xs:px-10 lg:px-36 sm:py-36 md:py-36 lg:py-30 bg-[#141833] flex">
          <p ref={designCopy2} className="content-center xs:text-xl sm:text-3xl md:text-3xl text-[#EDB6A2] md:w-[700px] lg:text-3xl lg:!leading-[2.8rem] lg:w-[900px] xl:text-3xl xl:!leading-[2.8rem] xl:w-[825px] sm:px-4 xl:px-12 font-ppNeue">
            Imagine warm tactile surfaces; rejuvenating natural light, rich-grain wood finishes, high-end appliances and bespoke cabinetry.
          </p>
        </article>
        <article className="text-center bg-[#141833] flex xs:pb-0 lg:pb-72">
          <img ref={designImage3} className="inline-block xs:w-full lg:w-6/12 lg:pr-8 xl:pr-16 xs:pr-0 lg:pl-48" alt="" src="../images/design3.jpg"></img>
          <img ref={designImage4} className="inline-block xs:hidden lg:inline-block xs:w-full relative top-[20rem] lg:w-6/12 lg:pl-8 xl:pl-16 xs:pr-0 lg:pr-48" alt="" src="../images/design4.jpg"></img>
        </article>
        <article className="xs:py-20 xs:px-10 lg:px-36 sm:py-36 md:py-36 lg:py-30 bg-[#141833] flex">
          <p ref={designCopy3} className="content-center xs:text-xl sm:text-3xl md:text-3xl text-[#EDB6A2] md:w-[700px] lg:text-3xl lg:!leading-[2.8rem] lg:w-[900px] xl:text-3xl xl:!leading-[2.8rem] xl:w-[800px] sm:px-4 xl:px-12 font-ppNeue">
            Our team is driven by the unbridled joy of creating beautiful interiors and has a meticulous commitment to perfecting the finest details.
          </p>
        </article>
        <article className="text-left bg-[#141833]">
          {/* <div
            ref={designImage5}
            style={{ backgroundImage: `url("../images/designFooter.jpg")` }}
            alt="hero"
            className="bg-no-repeat bg-center bg-cover relative h-screen w-full"
          ></div> */}
        </article>
        <article className="items-center bg-[#141833] xs:block lg:flex">
          <div className="w-2/4 text-left">
            <img ref={designImage6} className="xs:hidden lg:inline-block" alt="" src="../images/designFooter1.jpg"></img>
          </div>
          <div className="inline-block align-middle xs:w-full lg:w-2/4 xs:pl-0 xs:py-16 lg:pl-32">
            <h1 ref={designCopy4} className="content-center xs:text-center lg:text-left xs:text-xl sm:text-3xl md:text-3xl text-[#EDB6A2] lg:text-3xl lg:!leading-[2.8rem] xl:text-3xl xl:!leading-[2.8rem] font-ppNeue xs:pb-8 lg:pb-0">
              SEE PROJECTS
            </h1>
            <a href="/properties" rel="none">
              <button ref={designCta} className={buttonclassName}>
                SEE MORE
              </button>
            </a>
          </div>
        </article>
      </section>
    </>
  );
}

export default Design;
